import { Form } from '@approvalmax/ui/src/components';
import { PageRoute } from 'app/resources/components';
import { hocs as pageHocs } from 'modules/page';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useCompanyIdBasedOnUrl } from 'shared/hooks/useCompanyIdBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { Help, KycStepper } from '../resources/components';
import { WizardStep } from '../resources/constants';
import { pageConfig } from './config';
import { Layout } from './layout';
import { useAddPersonPopup } from './personsBasic/resources/components';
import { helpRoutes, wizardStepRoutes } from './resources/constants';
import { useWizardForm } from './resources/hooks/useWizardForm';

const Page = () => {
    const { companyId } = useCompanyIdBasedOnUrl();
    const { form, handleSubmit } = useWizardForm();
    const { addPersonPopup } = useAddPersonPopup();

    return (
        <>
            <Form form={form} onSubmit={handleSubmit}>
                <Layout
                    stepper={<KycStepper />}
                    content={
                        <Switch>
                            {wizardStepRoutes.map((route) => (
                                <PageRoute key={route.path} {...route} />
                            ))}

                            <Route path='*'>
                                <Redirect to={getPath(Path.walletsKycWizard, companyId, WizardStep.CompanyInfo)} />
                            </Route>
                        </Switch>
                    }
                    help={
                        <Switch>
                            {helpRoutes.map((route) => (
                                <Route key={route.path} path={route.path} component={Help} />
                            ))}
                        </Switch>
                    }
                />
            </Form>

            {addPersonPopup}
        </>
    );
};

export default pageHocs.withProtected({ Page, roles: pageConfig.access });
